import React from 'react';

const ProductListSkeleton = ({ count = 6 }) => {
  return (
    <div className="carta-v7-skeleton-card">
      {[...Array(count)].map((_, index) => (
        <div key={index} className="carta-v7-skeleton-row">
          <div className="carta-v7-skeleton-img" />
          <div className="carta-v7-skeleton-lines">
            <div className="carta-v7-skeleton-line carta-v7-skeleton-line--short" />
            <div className="carta-v7-skeleton-line carta-v7-skeleton-line--medium" />
            <div className="carta-v7-skeleton-line carta-v7-skeleton-line--long" />
          </div>
          <div className="carta-v7-skeleton-controls" />
        </div>
      ))}
    </div>
  );
};

export default ProductListSkeleton;
